















































































import Vue from 'vue'
import API from '@/utils/api'
import Component from 'vue-class-component'
import { namespace } from 'vuex-class'
import { BackendGame } from '@/models/BackendGame'
import { BackendGameFull } from '@/models/BackendGameFull'
import { Lineup } from '@/models/Lineup'
import GameCard from '@/components/GameCard.vue'
import Lineups from '@/components/Lineups.vue'
import { Roster } from '@/models/Roster'
import { Prediction } from '@/models/Prediction'
import { Status } from '@/models/Status'
import moment, { Moment } from 'moment'
const SnackbarStore = namespace('SnackbarStore')

@Component({
  components: { GameCard, Lineups },
})
export default class Main extends Vue {
  moment = moment
  @SnackbarStore.Mutation setSnackbarSuccess!: (message: string) => void
  games: BackendGame[] = []
  game: BackendGameFull | null = null
  rooms: string[] = ['DK', 'FD']
  selectedRoomIndex: number = 0
  lineupTypes: string[] = ['OFF', 'DEF']
  selectedLineupIndex: number = 0
  gameId: number | null = null
  loading: boolean = false
  statuses: Status[] = []
  finalTableErrors: string[] = []
  checkFinalTableLoading: boolean = false
  lastFinalTableCheck: Moment | null = null
  get room() {
    return this.rooms[this.selectedRoomIndex]
  }
  get currentLineupType() {
    return this.lineupTypes[this.selectedLineupIndex]
  }
  get sessionId() {
    return parseInt(this.$route.params.sessionId)
  }
  get homeLineups() {
    return this.filterLineups(true)
  }
  get awayLineups() {
    return this.filterLineups(false)
  }
  filterLineups(isHome: boolean) {
    let res: Lineup[] = []
    if (this.game) {
      res = this.game.lineups.filter(
        (lineup: Lineup) => lineup.is_home === isHome
      )
    }
    return res
  }
  get homeRoster() {
    return this.filterRoster(true)
  }
  get awayRoster() {
    return this.filterRoster(false)
  }
  filterRoster(isHome: boolean) {
    let res: Roster[] = []
    if (!this.game) {
      return res
    }
    let teamId: number = isHome
      ? this.game.main_game.home_team.id
      : this.game.main_game.away_team.id
    if (this.game) {
      res = this.game.roster.filter(
        (roster: Roster) => roster.team.id === teamId
      )
    }
    return res
  }
  get homeRgPredictions() {
    return this.filterRgPredictions(true)
  }
  get awayRgPredictions() {
    return this.filterRgPredictions(false)
  }
  filterRgPredictions(isHome: boolean) {
    let res: Prediction[] = []
    if (!this.game) {
      return res
    }
    let teamId: number = isHome
      ? this.game.main_game.home_team.id
      : this.game.main_game.away_team.id
    if (this.game) {
      res = this.game.rg_predictions.filter(
        (prediction: Prediction) => prediction.team_id === teamId
      )
    }
    return res
  }
  get homeFacts() {
    return this.filterFacts(true)
  }
  get awayFacts() {
    return this.filterFacts(false)
  }
  filterFacts(isHome: boolean) {
    let res: Prediction[] = []
    if (!this.game) {
      return res
    }
    let teamId: number = isHome
      ? this.game.main_game.home_team.id
      : this.game.main_game.away_team.id
    if (this.game) {
      res = this.game.facts.filter(
        (prediction: Prediction) => prediction.team_id === teamId
      )
    }
    return res
  }
  get homeAwPredictions() {
    return this.filterAwPredictions(true)
  }
  get awayAwPredictions() {
    return this.filterAwPredictions(false)
  }
  filterAwPredictions(isHome: boolean) {
    let res: Prediction[] = []
    if (!this.game) {
      return res
    }
    let teamId: number = isHome
      ? this.game.main_game.home_team.id
      : this.game.main_game.away_team.id
    if (this.game) {
      res = this.game.aw_predictions.filter(
        (prediction: Prediction) => prediction.team_id === teamId
      )
    }
    return res
  }
  get homeOurPredictions() {
    return this.filterOurPredictions(true)
  }
  get awayOurPredictions() {
    return this.filterOurPredictions(false)
  }
  filterOurPredictions(isHome: boolean) {
    let res: Prediction[] = []
    if (!this.game) {
      return res
    }
    let teamId: number = isHome
      ? this.game.main_game.home_team.id
      : this.game.main_game.away_team.id
    if (this.game) {
      res = this.game.our_predictions.filter(
        (prediction: Prediction) => prediction.team_id === teamId
      )
    }
    return res
  }
  saveGame() {
    if (!this.game) return
    this.loading = true
    return API.saveGame(this.game)
      .then((r) => {
        return this.loadGame()
      })
      .catch((err) => {})
      .finally(() => {
        this.loading = false
      })
  }
  createFinalTable() {
    this.loading = true
    return API.createFinalTableForSession(this.sessionId)
      .then((r) => {
        this.setSnackbarSuccess(`Message ${r.data.id} created`)
      })
      .catch((err) => {})
      .finally(() => {
        this.loading = false
      })
  }
  checkCreateFinalTable() {
    this.checkFinalTableLoading = true
    this.finalTableErrors = []
    return API.checkCreateFinalTableForSession(this.sessionId)
      .then((r) => {
        this.lastFinalTableCheck = this.moment()
        if (r.data.errors.length > 0) {
          this.finalTableErrors = r.data.errors
        } else {
          this.setSnackbarSuccess(`No errors`)
        }
      })
      .catch((err) => {})
      .finally(() => {
        this.checkFinalTableLoading = false
      })
  }
  loadSessionGames() {
    this.loading = true
    API.loadStatuses().then((r) => {
      this.statuses = r.data
    })
    return API.loadGamesForSession(this.sessionId)
      .then((r) => {
        this.games = r.data
        this.loadGame()
      })
      .catch((err) => {})
      .finally(() => {
        this.loading = false
      })
  }
  loadGame() {
    if (this.gameId) {
      this.loading = true
      return API.loadGame(this.gameId)
        .then((r) => {
          this.game = r.data
        })
        .catch((err) => {})
        .finally(() => {
          this.loading = false
        })
    }
  }
  changeGame(gameId: number) {
    this.gameId = gameId
    return this.loadGame()
  }
  mounted() {
    this.loadSessionGames()
  }
}
